/* Touché · Pop-up obligatorio para productos A PEDIDO
   ------------------------------------------------------------------
   - Se abre solo al entrar a la ficha de un producto a pedido (también si se
     llega directo desde Meta Ads) y no en productos en stock.
   - Hasta que la clienta marca la casilla y toca "ENTENDIDO, CONTINUAR" no se
     puede agregar al carrito ni comprar ese producto (ficha, barra fija, vista
     rápida, compra rápida desde tarjetas, "Comprar ahora" y carrito).
   - La aceptación queda en el pedido: propiedad de línea "_Condiciones a pedido"
     (fecha y hora) en cada producto a pedido + atributo del carrito
     "Condiciones a pedido aceptadas".
   - Después de aceptar, la clienta puede volver a consultar las condiciones:
     al entrar de nuevo a la ficha el pop-up se abre otra vez, con la casilla
     ya marcada y el botón habilitado (un toque para continuar o cerrar).
   - Mientras está abierto se coloca al final del <body> con el z-index máximo,
     para quedar por encima de los botones flotantes (WhatsApp, etc.).
   Markup: snippets/touche-pedido-popup.liquid · Estilos: assets/touche-pedido.css
   Identificación por variante: snippets/touche-pedido-flag.liquid */
(function () {
  'use strict';
  if (window.__touchePedido) return;
  window.__touchePedido = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SESSION_KEY = 'touchePedidoAceptado_v1';
  var PAY_HOSTS = '.f-product-form__button-dynamic, .shopify-payment-button, shopify-accelerated-checkout, shopify-buy-it-now-button';
  var CART_PAY_HOSTS = '.cart__dynamic-checkout-buttons, .additional-checkout-buttons';
  var CHECKOUT_SEL = 'button[name="checkout"], input[name="checkout"], a[href^="/checkout"]';

  var cfg = {
    template: '',
    stockUrl: '/collections/productos-en-stock',
    prop: '_Condiciones a pedido',
    attr: 'Condiciones a pedido aceptadas',
    cart: []
  };

  var modal = null, dialog = null, checkbox = null, acceptBtn = null;
  var pending = null;   // qué hacer al aceptar (seguir con la compra)
  var context = null;   // { productIds: [...], cart: {...} }
  var lastFocus = null;
  var bypass = false;
  var acked = {};       // productId -> "dd/mm/aaaa hh:mm" (solo esta visita)
  var handleCache = {}; // handle -> Promise
  var handleInfo = {};  // handle -> resultado ya resuelto (uso sincrónico)

  /* ---------------- utilidades ---------------- */
  function readCfg() {
    var el = document.getElementById('TouchePedidoConfig');
    if (!el) return;
    try {
      var c = JSON.parse(el.textContent);
      for (var k in c) if (c[k] !== null && c[k] !== undefined) cfg[k] = c[k];
    } catch (e) {}
    if (!Array.isArray(cfg.cart)) cfg.cart = [];
  }
  function loadAck() {
    try { acked = JSON.parse(sessionStorage.getItem(SESSION_KEY) || '{}') || {}; } catch (e) { acked = {}; }
  }
  function saveAck() {
    try { sessionStorage.setItem(SESSION_KEY, JSON.stringify(acked)); } catch (e) {}
  }
  function isAcked(pid) { return !!(pid && acked[String(pid)]); }
  function markAck(pid, s) { if (!pid) return; acked[String(pid)] = s; saveAck(); }

  function stamp() {
    var d = new Date();
    try {
      var f = new Intl.DateTimeFormat('es-AR', {
        timeZone: 'America/Argentina/Buenos_Aires',
        day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false
      });
      var parts = {};
      f.formatToParts(d).forEach(function (p) { parts[p.type] = p.value; });
      if (parts.day && parts.hour) {
        return parts.day + '/' + parts.month + '/' + parts.year + ' ' + parts.hour + ':' + parts.minute;
      }
    } catch (e) {}
    function two(n) { return (n < 10 ? '0' : '') + n; }
    return two(d.getDate()) + '/' + two(d.getMonth() + 1) + '/' + d.getFullYear() + ' ' + two(d.getHours()) + ':' + two(d.getMinutes());
  }
  function propValue(s) { return 'Aceptadas el ' + String(s).replace(' ', ' a las ') + ' hs (Argentina)'; }
  function attrValue(s) { return 'Sí · ' + s + ' hs (Argentina)'; }

  function handleize(str) {
    var s = String(str || '').toLowerCase();
    try { s = s.normalize('NFD').replace(new RegExp('[' + String.fromCharCode(768) + '-' + String.fromCharCode(879) + ']', 'g'), ''); } catch (e) {}
    return s.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function isPedidoTag(tags) {
    for (var i = 0; i < (tags || []).length; i++) {
      var h = handleize(tags[i]);
      if (h === 'a-pedido' || h === 'apedido') return true;
    }
    return false;
  }
  function fetchJSON(url, opts) {
    opts = opts || {};
    opts.credentials = 'same-origin';
    opts.headers = opts.headers || {};
    opts.headers.Accept = 'application/json';
    return fetch(url, opts).then(function (r) { return r.json(); });
  }

  /* ---------------- identificación "a pedido" ---------------- */
  function parseFlag(el) {
    if (!el) return null;
    var map = {};
    try { map = JSON.parse(el.getAttribute('data-touche-pedido-map') || '{}') || {}; } catch (e) {}
    return {
      id: el.getAttribute('data-touche-pedido-product') || '',
      handle: el.getAttribute('data-touche-pedido-handle') || '',
      title: el.getAttribute('data-touche-pedido-title') || '',
      any: el.getAttribute('data-touche-pedido-any') === 'true',
      map: map
    };
  }
  function pageFlag() {
    return parseFlag(document.querySelector('[data-touche-pedido-page] [data-touche-pedido]'));
  }
  function flagByVariant(vid) {
    if (!vid) return null;
    var els = document.querySelectorAll('[data-touche-pedido]');
    for (var i = 0; i < els.length; i++) {
      var f = parseFlag(els[i]);
      if (f && f.map[vid]) return f;
    }
    return null;
  }
  function variantIdFrom(form) {
    if (!form) return null;
    var input = form.querySelector('[name="id"]');
    if (input && input.value) return String(input.value);
    if (form.id) {
      var ext = document.querySelector('[name="id"][form="' + form.id + '"]');
      if (ext && ext.value) return String(ext.value);
    }
    return null;
  }
  function isCartAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    return (form.getAttribute('action') || '').indexOf('/cart/add') !== -1;
  }
  /* Tipo de lo que agregaría este formulario: 'pedido' | 'stock' | 'agotado' | null (no se sabe) */
  function resolveForm(form) {
    var vid = variantIdFrom(form);
    var flag = parseFlag(form.querySelector('[data-touche-pedido]'));
    if (!flag) {
      var scope = form.closest('.product-card, product-info, modal-dialog, sticky-atc-bar, .f-product-single__blocks, .f-product-single, .featured-product');
      if (scope) flag = parseFlag(scope.querySelector('[data-touche-pedido]'));
    }
    if (!flag || (vid && !flag.map[vid])) {
      var byV = flagByVariant(vid);
      if (byV) flag = byV;
    }
    if (!flag) {
      var pf = pageFlag();
      if (pf && vid && pf.map[vid]) flag = pf;
    }
    if (!flag) return { type: null, flag: null, vid: vid };
    var type = vid && flag.map[vid] ? flag.map[vid] : (flag.any ? 'pedido' : 'stock');
    return { type: type, flag: flag, vid: vid };
  }
  /* Último recurso (tarjetas sin marca): por etiqueta, consultando /products/handle.js */
  function productByHandle(handle) {
    if (!handle) return Promise.resolve(null);
    if (!handleCache[handle]) {
      handleCache[handle] = fetchJSON(ROOT + 'products/' + handle + '.js')
        .then(function (p) {
          if (!p || !p.id) return null;
          return { id: String(p.id), title: p.title || '', handle: handle, pedido: isPedidoTag(p.tags) };
        })
        .catch(function () { return null; })
        .then(function (info) { handleInfo[handle] = info || false; return info; });
    }
    return handleCache[handle];
  }
  /* Resolución inmediata para formularios sin marca (tarjetas, vista rápida):
     usa lo ya consultado y, si falta, dispara la consulta y vuelve a aplicar las capas. */
  function resolveFormSync(form) {
    var r = resolveForm(form);
    if (r.type !== null) return r;
    var handle = handleFromForm(form);
    if (!handle) return r;
    var info = handleInfo[handle];
    if (info === undefined) {
      productByHandle(handle).then(scheduleShields);
      return r;
    }
    if (!info) return { type: 'stock', flag: null, vid: r.vid };
    var map = {};
    if (r.vid) map[r.vid] = info.pedido ? 'pedido' : 'stock';
    return { type: info.pedido ? 'pedido' : 'stock', flag: { id: info.id, handle: handle, title: info.title, any: info.pedido, map: map }, vid: r.vid };
  }
  function handleFromForm(form) {
    var card = form.closest('.product-card, .f-cart-item, product-info, modal-dialog');
    var a = card ? card.querySelector('a[href*="/products/"]') : null;
    var href = a ? a.getAttribute('href') : null;
    if (!href) {
      var pi = form.closest('product-info');
      href = pi ? pi.getAttribute('data-product-url') : null;
    }
    if (!href) return null;
    var h = (href.split('/products/')[1] || '').split(/[?#\/]/)[0];
    return h || null;
  }

  /* ---------------- propiedad de línea / atributo del carrito ---------------- */
  function ensureProp(form, value) {
    if (!form) return;
    var name = 'properties[' + cfg.prop + ']';
    var inputs = form.querySelectorAll('input');
    var input = null;
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].name === name) { input = inputs[i]; break; }
    }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.setAttribute('data-touche-pedido-prop', '');
      form.appendChild(input);
    }
    input.value = value;
    input.disabled = false;
  }
  function ensurePropAll(productId, value) {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var r = resolveFormSync(forms[i]);
      if (r.flag && String(r.flag.id) === String(productId)) ensureProp(forms[i], value);
    }
  }
  function cartUpdateAttr(value) {
    var body = { attributes: {} };
    body.attributes[cfg.attr] = value;
    return fetchJSON(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).catch(function () {});
  }

  /* ---------------- carrito: líneas a pedido sin aceptación ---------------- */
  function cfgCartByVariant(vid) {
    for (var i = 0; i < cfg.cart.length; i++) {
      if (String(cfg.cart[i].variant) === String(vid)) return cfg.cart[i];
    }
    return null;
  }
  function cartHasPending() {
    for (var i = 0; i < cfg.cart.length; i++) {
      if (cfg.cart[i].pedido && !cfg.cart[i].accepted) return true;
    }
    return false;
  }
  function isPedidoItem(item) {
    var vid = String(item.variant_id);
    var c = cfgCartByVariant(vid);
    if (c) return Promise.resolve(!!c.pedido);
    var f = flagByVariant(vid);
    if (f) return Promise.resolve(f.map[vid] === 'pedido');
    return productByHandle(item.handle).then(function (p) { return !!(p && p.pedido); });
  }
  function checkCart() {
    return fetchJSON(ROOT + 'cart.js').then(function (cart) {
      var items = (cart && cart.items) || [];
      var tasks = items.map(function (item, i) {
        var accepted = !!(item.properties && item.properties[cfg.prop]);
        return isPedidoItem(item).then(function (pedido) {
          return { line: i + 1, item: item, pedido: pedido, accepted: accepted };
        });
      });
      return Promise.all(tasks).then(function (rows) {
        return {
          cart: cart,
          rows: rows,
          pending: rows.filter(function (r) { return r.pedido && !r.accepted; })
        };
      });
    });
  }
  function acceptCartLines(res, s) {
    var value = propValue(s);
    /* de la última línea a la primera: si Shopify une dos líneas iguales, no se corren los índices pendientes */
    var lines = res.pending.slice().sort(function (a, b) { return b.line - a.line; });
    var chain = Promise.resolve();
    lines.forEach(function (row) {
      chain = chain.then(function () {
        var props = {};
        var p = row.item.properties || {};
        for (var k in p) props[k] = p[k];
        props[cfg.prop] = value;
        return fetchJSON(ROOT + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: row.line, quantity: row.item.quantity, properties: props })
        }).catch(function () {});
      });
    });
    return chain.then(function () {
      res.pending.forEach(function (row) {
        var c = cfgCartByVariant(row.item.variant_id);
        if (c) c.accepted = true;
        else cfg.cart.push({ key: row.item.key, variant: row.item.variant_id, product: row.item.product_id, handle: row.item.handle, title: row.item.product_title, pedido: true, accepted: true });
        markAck(row.item.product_id, s);
      });
      return cartUpdateAttr(attrValue(s));
    });
  }

  /* ---------------- capa sobre "Comprar ahora" / botones de pago ---------------- */
  function applyShields() {
    var hosts = document.querySelectorAll(PAY_HOSTS + ', ' + CART_PAY_HOSTS);
    for (var i = 0; i < hosts.length; i++) {
      var host = hosts[i];
      if (host.parentElement && host.parentElement.closest(PAY_HOSTS)) continue; /* solo el contenedor exterior */
      var need = false;
      var form = host.closest('form[action*="/cart/add"]');
      if (form) {
        var r = resolveFormSync(form);
        need = r.type === 'pedido' && !isAcked(r.flag.id);
      } else if (host.matches(CART_PAY_HOSTS)) {
        need = cartHasPending();
      }
      var shield = null;
      for (var c = 0; c < host.children.length; c++) {
        if (host.children[c].classList.contains('touche-pedido-shield')) { shield = host.children[c]; break; }
      }
      if (need && !shield) {
        host.classList.add('touche-pedido-shield-host');
        shield = document.createElement('div');
        shield.className = 'touche-pedido-shield';
        shield.setAttribute('aria-hidden', 'true');
        host.appendChild(shield);
      } else if (!need && shield) {
        shield.parentNode.removeChild(shield);
        host.classList.remove('touche-pedido-shield-host');
      }
    }
  }
  var shieldTimer = null;
  function scheduleShields() {
    clearTimeout(shieldTimer);
    shieldTimer = setTimeout(applyShields, 120);
  }

  /* ---------------- el pop-up ---------------- */
  function getModal() {
    if (!modal || !modal.isConnected) {
      modal = document.getElementById('TouchePedidoPopup');
      dialog = modal ? modal.querySelector('.tpp__dialog') : null;
      checkbox = modal ? modal.querySelector('[data-tpp-check]') : null;
      acceptBtn = modal ? modal.querySelector('[data-tpp-accept]') : null;
    }
    return modal;
  }
  function setAccept(on) {
    if (!acceptBtn) return;
    acceptBtn.disabled = !on;
    acceptBtn.setAttribute('aria-disabled', on ? 'false' : 'true');
  }
  function openModal(ctx, resume, prechecked) {
    var m = getModal();
    if (!m) { if (resume) resume(); return; }
    context = ctx || {};
    pending = resume || null;
    if (checkbox) checkbox.checked = !!prechecked;
    setAccept(!!prechecked);
    /* Al final del <body> con z-index máximo: queda por encima de los widgets flotantes (WhatsApp, etc.) */
    if (m.parentNode !== document.body || m !== document.body.lastElementChild) {
      try { document.body.appendChild(m); } catch (e) {}
    }
    if (m.hidden) lastFocus = document.activeElement;
    m.hidden = false;
    m.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('touche-pedido-open');
    void m.offsetWidth;
    m.classList.add('is-open');
    if (dialog) {
      dialog.scrollTop = 0;
      setTimeout(function () {
        try { dialog.focus({ preventScroll: true }); } catch (e) { try { dialog.focus(); } catch (e2) {} }
      }, 30);
    }
  }
  function closeModal(restoreFocus) {
    var m = getModal();
    if (!m || m.hidden) return;
    m.classList.remove('is-open');
    m.setAttribute('aria-hidden', 'true');
    m.hidden = true;
    document.documentElement.classList.remove('touche-pedido-open');
    pending = null;
    context = null;
    if (restoreFocus !== false && lastFocus && lastFocus.focus) {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
  }
  function accept() {
    if (!acceptBtn || acceptBtn.disabled || acceptBtn.classList.contains('is-busy')) return;
    if (!checkbox || !checkbox.checked) return;
    var s = stamp();
    var resume = pending;
    var ctx = context || {};
    var ids = ctx.productIds || [];
    var allAcked = ids.length > 0;
    ids.forEach(function (id) { if (!isAcked(id)) allAcked = false; });
    if (allAcked) {
      /* Ya había aceptado (volvió a consultar): se conserva la fecha original */
      s = acked[String(ids[0])];
      ids.forEach(function (id) { ensurePropAll(id, propValue(acked[String(id)] || s)); });
      acceptBtn.classList.add('is-busy');
      var work0 = ctx.cart ? acceptCartLines(ctx.cart, s) : Promise.resolve();
      Promise.resolve(work0).catch(function () {}).then(function () {
        acceptBtn.classList.remove('is-busy');
        applyShields();
        closeModal(false);
        if (resume) { try { resume(); } catch (e) {} }
      });
      return;
    }
    ids.forEach(function (id) { markAck(id, s); });
    ids.forEach(function (id) { ensurePropAll(id, propValue(s)); });
    acceptBtn.classList.add('is-busy');
    var work = ctx.cart ? acceptCartLines(ctx.cart, s) : cartUpdateAttr(attrValue(s));
    Promise.resolve(work).catch(function () {}).then(function () {
      acceptBtn.classList.remove('is-busy');
      applyShields();
      closeModal(false);
      if (resume) { try { resume(); } catch (e) {} }
    });
  }

  /* ---------------- continuar con la compra después de aceptar ---------------- */
  function resubmit(form, submitter) {
    bypass = true;
    try {
      if (typeof form.requestSubmit === 'function') {
        try {
          if (submitter && submitter.form === form && submitter.isConnected) form.requestSubmit(submitter);
          else form.requestSubmit();
        } catch (e) { form.requestSubmit(); }
      } else {
        var ev = new Event('submit', { bubbles: true, cancelable: true });
        if (form.dispatchEvent(ev)) form.submit();
      }
    } finally {
      bypass = false;
    }
  }
  function clickPayButton(host, btn) {
    var target = (btn && btn.tagName === 'BUTTON' && btn.isConnected) ? btn : null;
    if (!target && host) {
      var list = host.querySelectorAll('button.shopify-payment-button__button');
      for (var i = 0; i < list.length; i++) {
        if (list[i].className.indexOf('--hidden') === -1 && !list[i].disabled) { target = list[i]; break; }
      }
    }
    if (!target) return; /* botón de billetera (iframe): la clienta vuelve a tocarlo, ya sin bloqueo */
    bypass = true;
    try { target.click(); } finally { bypass = false; }
  }
  function goCheckout(el) {
    el.__touchePedidoOk = true;
    try { el.click(); } finally {
      setTimeout(function () { el.__touchePedidoOk = false; }, 6000);
    }
  }

  /* ---------------- 1) Agregar al carrito (ficha, barra fija, vista rápida, tarjetas) ---------------- */
  window.addEventListener('submit', function (e) {
    if (bypass) return;
    var form = e.target;
    if (!isCartAddForm(form)) return;
    var r = resolveFormSync(form);
    var submitter = e.submitter;

    if (r.type === null) {
      var handle = handleFromForm(form);
      if (!handle) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      productByHandle(handle).then(function (p) {
        if (!p || !p.pedido) { resubmit(form, submitter); return; }
        if (isAcked(p.id)) { ensureProp(form, propValue(acked[p.id])); resubmit(form, submitter); return; }
        openModal({ productIds: [p.id] }, function () {
          ensureProp(form, propValue(acked[p.id] || stamp()));
          resubmit(form, submitter);
        });
      });
      return;
    }
    if (r.type !== 'pedido') return;
    var pid = r.flag.id;
    if (isAcked(pid)) { ensureProp(form, propValue(acked[pid])); return; }
    e.preventDefault();
    e.stopImmediatePropagation();
    openModal({ productIds: [pid] }, function () { resubmit(form, submitter); });
  }, true);

  /* ---------------- 2) "Comprar ahora" / botones de pago dinámicos ---------------- */
  window.addEventListener('click', function (e) {
    if (bypass) return;
    var path = typeof e.composedPath === 'function' ? e.composedPath() : [];
    if (!path.length) { var n = e.target; while (n) { path.push(n); n = n.parentNode; } }
    var host = null, btn = null;
    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (!node || node.nodeType !== 1) continue;
      if (!btn && node.tagName === 'BUTTON') btn = node;
      if (node.matches && node.matches(PAY_HOSTS + ', ' + CART_PAY_HOSTS)) { host = node; break; }
    }
    if (!host) return;
    var form = host.closest('form[action*="/cart/add"]');
    if (form) {
      var r = resolveFormSync(form);
      if (r.type === null) {
        var handle = handleFromForm(form);
        if (!handle) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        productByHandle(handle).then(function (p) {
          if (!p || !p.pedido) { clickPayButton(host, btn); return; }
          if (isAcked(p.id)) { ensureProp(form, propValue(acked[p.id])); clickPayButton(host, btn); return; }
          openModal({ productIds: [p.id] }, function () {
            ensureProp(form, propValue(acked[p.id] || stamp()));
            clickPayButton(host, btn);
          });
        });
        return;
      }
      if (r.type !== 'pedido') return;
      var pid = r.flag.id;
      if (isAcked(pid)) { ensureProp(form, propValue(acked[pid])); return; }
      e.preventDefault();
      e.stopImmediatePropagation();
      openModal({ productIds: [pid] }, function () {
        ensureProp(form, propValue(acked[pid] || stamp()));
        clickPayButton(host, btn);
      });
      return;
    }
    /* Botones de pago de la página de carrito */
    var shieldHit = e.target && e.target.closest && e.target.closest('.touche-pedido-shield');
    if (!shieldHit && !cartHasPending()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    checkCart().then(function (res) {
      if (!res.pending.length) { applyShields(); return; }
      var ids = res.pending.map(function (row) { return String(row.item.product_id); });
      openModal({ productIds: ids, cart: res }, null);
    }).catch(function () { applyShields(); });
  }, true);

  /* ---------------- 3) Finalizar compra con productos a pedido en el carrito ---------------- */
  function gateCheckout(e, el) {
    if (bypass || !el || el.__touchePedidoOk) return;
    if (el.closest && el.closest('#TouchePedidoPopup')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    checkCart().then(function (res) {
      if (!res.pending.length) { goCheckout(el); return; }
      var ids = res.pending.map(function (row) { return String(row.item.product_id); });
      openModal({ productIds: ids, cart: res }, function () { goCheckout(el); });
    }).catch(function () { goCheckout(el); });
  }
  window.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest(CHECKOUT_SEL) : null;
    if (!el) return;
    gateCheckout(e, el);
  }, true);
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var sub = e.submitter;
    if (!sub || sub.name !== 'checkout') return;
    gateCheckout(e, sub);
  }, true);

  /* ---------------- botones del pop-up ---------------- */
  document.addEventListener('click', function (e) {
    var m = getModal();
    if (!m || m.hidden || !e.target || !e.target.closest) return;
    if (e.target.closest('[data-tpp-accept]')) { e.preventDefault(); accept(); return; }
    if (e.target.closest('[data-tpp-close]')) { e.preventDefault(); closeModal(true); return; }
    if (e.target.closest('[data-tpp-stock]')) { document.documentElement.classList.remove('touche-pedido-open'); }
  });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-tpp-check]')) setAccept(!!e.target.checked);
  });
  document.addEventListener('keydown', function (e) {
    var m = getModal();
    if (!m || m.hidden) return;
    if (e.key === 'Escape') { closeModal(true); return; }
    if (e.key === 'Tab') {
      var all = m.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])');
      var list = Array.prototype.filter.call(all, function (el) { return el.offsetParent !== null || el.getAttribute('data-tpp-check') !== null; });
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === dialog)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------------- apertura automática en la ficha de un producto a pedido ---------------- */
  function pageVariantId() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].closest('.product-card, modal-dialog')) continue;
      var vid = variantIdFrom(forms[i]);
      if (vid) return vid;
    }
    var m = (window.location.search || '').match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }
  var autoOpened = false;
  function maybeAutoOpen() {
    var pf = pageFlag();
    if (!pf || !pf.any) return;
    var vid = pageVariantId();
    var type = vid && pf.map[vid] ? pf.map[vid] : 'pedido';
    if (type !== 'pedido') return;
    var already = isAcked(pf.id);
    if (already) { ensurePropAll(pf.id, propValue(acked[pf.id])); applyShields(); }
    /* Se abre una vez al entrar a la ficha. Si ya aceptó, se abre igual (puede volver a
       leer las condiciones) con la casilla marcada. Al cambiar de variante no se repite;
       el bloqueo al agregar/comprar sigue funcionando aparte. */
    if (autoOpened) return;
    var m = getModal();
    if (!m || !m.hidden) return;
    autoOpened = true;
    openModal({ productIds: [pf.id] }, null, already);
  }

  /* ---------------- arranque ---------------- */
  function init() {
    readCfg();
    loadAck();
    getModal();
    applyShields();
    setTimeout(maybeAutoOpen, 350);

    /* cambio de variante en la ficha */
    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.closest || !e.target.closest('variant-picker, variant-selects, .f-product-single__block--variant_picker, sticky-atc-bar')) return;
      setTimeout(function () { maybeAutoOpen(); applyShields(); }, 80);
    });
    /* vista rápida, barra fija y carrito que se vuelven a dibujar */
    document.addEventListener('quick-view:loaded', scheduleShields);
    document.addEventListener('product-ajax:added', scheduleShields);
    if ('MutationObserver' in window) {
      new MutationObserver(scheduleShields).observe(document.body, { childList: true, subtree: true });
    }
    window.addEventListener('pageshow', function (ev) {
      if (ev.persisted) { bypass = false; loadAck(); applyShields(); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.TouchePedido = {
    open: function () { openModal({ productIds: [] }, null); },
    reset: function () { acked = {}; saveAck(); applyShields(); },
    check: checkCart
  };
})();
